import React from "react";

// Flat page-level surface behind all content (calm system, no glow blobs).
// `intensity` is accepted for mount-site compatibility; the surface is flat.
export const NeonBackground = ({ intensity = 1 }) => {
    return (
        <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0"
            style={{ background: "var(--rf-surface-page)" }}
        />
    );
};
